<!--
  SINGLE FORM VIEW FOR © AREA 19, OCG WEB APP.

  DEVELOPED IN MONTREAL, QC, CANADA.
  MARCH 2025.
 -->

<script setup lang="tsx">
import { onMounted, ref } from 'vue';

import VersionNumber from '../components/VersionNumber.vue';

const props = defineProps({
  width: {
    type: String,
  },
  maxWidth: {
    type: String,
  },
});
const loaded = ref(false);

onMounted(() => {
  setTimeout(() => {
    loaded.value = true;
  }, 100);
});
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-0 items-center justify-center overflow-hidden py-4 px-3">
    <div
      class="glass-panel py-6 px-6 relative not-loaded self-center form"
      :class="{
        'opacity-100': loaded,
        'opacity-0': !loaded,
      }"
      :style="{
        width: props.width ? props.width : '32rem',
        maxWidth: props.maxWidth ? props.maxWidth : (props.width === '100%' ? '80vw' : '90vw'),
      }"
    >
      <slot />
      <VersionNumber />
    </div>
  </div>
</template>

<style scoped>
.form {
  min-width: 200px;
  max-height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
